/**
 * Copyright (C) 2025 GIP-RECIA, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { Link } from 'common/types/index.ts'

export enum InformationItem {
  Adress = 'adress',
  Mail = 'mail',
  Phone = 'phone',
  Website = 'website',
}

export interface Information {
  id: InformationItem
  icon?: IconDefinition
  link?: Link | null
  value?: string
}

export type InformationConfig = Record<
  InformationItem,
  Omit<Partial<Information>, 'id'>
>

export interface InfoEtabData {
  'image-url'?: string
  'svg-url'?: string
  'etab-name'?: string
  'acad-name'?: string
  'information'?: Partial<InformationConfig>
}
